export default "__VITE_ASSET__C6ENUb1t__"